// withProviders.tsx
import React from "react"

import { BlurProvider } from "@fuse/sharedComponents/blurWrapper/BlurContext"
import { GlobalAlert } from "@fuse/sharedComponents/globalAlert"
import { GlobalImageModal } from "@fuse/sharedComponents/globalImageModal"
import { GlobalLoaderProvider } from "@fuse/sharedComponents/globalLoader/GlobalLoaderContext"
import GlobalQuickSignUpModalState from "@fuse/sharedComponents/globalQuickSignUpModal"
import { GlobalSearchProvider } from "@fuse/sharedComponents/globalSearchContext"
import GlobalShare from "@fuse/sharedComponents/globalShare"
import { GlobalShareProvider } from "@fuse/sharedComponents/globalShare/GlobalShareContext"
import UserStateUpdater from "@fuse/sharedComponents/userStateUpdater"

const withProviders = (Component: React.FC) => {
  return function WrappedComponent(props: any) {
    return (
      <BlurProvider>
        <GlobalLoaderProvider>
          <GlobalShareProvider>
            <UserStateUpdater />
            <GlobalQuickSignUpModalState>
              <GlobalSearchProvider>
                <GlobalImageModal>
                  <GlobalAlert>
                    <Component {...props} />
                    <GlobalShare />
                  </GlobalAlert>
                </GlobalImageModal>
              </GlobalSearchProvider>
            </GlobalQuickSignUpModalState>
          </GlobalShareProvider>
        </GlobalLoaderProvider>
      </BlurProvider>
    )
  }
}

export default withProviders
